'use client';

import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { productDetailsApi, ResponseProductDetailsType } from '../service/getProductDetails';
import ProductPageSkeleton from '@/src/components/animation/ProductPageSkeleton';
import NotFound from '@/src/components/NotFound';
import { ProductDetails } from './product-details';
import { useSearchParams } from 'next/navigation';
import Container from '@/src/components/ui/container';

type Props = {
  productId: string | null;
  storeId: string | null;
};

const useProductDetails = (productId: string | null, storeId: string | null) => {
  return useQuery<ResponseProductDetailsType>({
    queryKey: ['product', productId, storeId],
    queryFn: async () => await productDetailsApi.getProductDetails(storeId!, productId!),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    enabled: !!productId && !!storeId,
  });
};

const RenderClientProductDetails: FC<Props> = ({
  productId: productFormProps,
  storeId: StoreFromProps,
}) => {
  const params = useSearchParams();
  const productId = params.get('productId') || productFormProps;
  const storeId = params.get('storeId') || StoreFromProps;

  const { data, isLoading, isError } = useProductDetails(productId, storeId);

  if (!productId || !storeId) {
    return <div>Product ID or Store ID is missing</div>;
  }

  if (isLoading) {
    return <ProductPageSkeleton />;
  }
  if (isError) {
    return <NotFound title="Product not found " />;
  }

  if (!data) {
    return <NotFound title="Product not found " />;
  }

  return <ProductDetails productInfo={data} />;
};

export default RenderClientProductDetails;
